import {Tag} from 'primereact/tag'
import React from 'react'
import {isArrayAndNotEmpty} from '../../observations/Utils'

export const hcpColumnList = [
    {
        field: 'title',
        header: 'Title',
        initialShown: true,
        body: rowData => rowData.titleValue || 'N/A',
    },
    {
        field: 'fullName',
        header: 'Full Name',
        initialShown: true,
        body: rowData => (
            <div className="flex aligns-item-center">
                {rowData?.fullName ? (
                    <React.Fragment>
                        {rowData?.avatar ? (
                            <div className="mr-2">
                                <img
                                    src={rowData?.avatar}
                                    style={{width: 30, height: 30}}
                                />
                            </div>
                        ) : (
                            ''
                        )}
                        <div className="align-self-center">
                            {rowData.fullName}
                        </div>
                    </React.Fragment>
                ) : (
                    'N/A'
                )}
            </div>
        ),
    },
    {
        field: 'firstName',
        header: 'First Name',
        initialShown: false,
        body: rowData => rowData.firstName || 'N/A',
    },
    {
        field: 'lastName',
        header: 'Last Name',
        initialShown: false,
        body: rowData => rowData.lastName || 'N/A',
    },
    {
        field: 'email',
        header: 'Email',
        initialShown: true,
        body: rowData => rowData.email || 'N/A',
    },
    {
        header: 'Number of Hospitals',
        field: 'hospitalIds',
        initialShown: true,
        body: rowData =>
            isArrayAndNotEmpty(rowData?.hospitalIds) ? (
                <span>
                    <span className="font-bold text-darkcyan">
                        {rowData?.hospitalIds?.length}{' '}
                        <span className="lowercase">hospital(s) in total</span>
                    </span>
                </span>
            ) : (
                <span>
                    <span className="font-bold text-danger">None</span>
                </span>
            ),
    },
    {
        header: 'Number of Roles',
        field: 'userRoleIds',
        initialShown: true,
        body: rowData =>
            isArrayAndNotEmpty(rowData?.userRoleIds) ? (
                <span>
                    <span className="font-bold text-darkcyan">
                        {rowData?.userRoleIds?.length}{' '}
                        <span className="lowercase">role(s) in total</span>
                    </span>
                </span>
            ) : (
                <span>
                    <span className="font-bold text-danger">None</span>
                </span>
            ),
    },
    {
        header: 'Qualified Roles',
        field: 'userRoles',
        initialShown: true,
        body: rowData => {
            const roles = rowData?.userRoles
            let noOfQualifiedRoles = 0

            if (isArrayAndNotEmpty(roles)) {
                roles.forEach(role => {
                    if (role?.active && role?.permissions?.length > 0) {
                        role.permissions.forEach(rolePermission => {
                            if (rolePermission?.qualified) {
                                noOfQualifiedRoles++
                            }
                        })
                    }
                })
            }

            return noOfQualifiedRoles ? (
                <span>
                    <span className="font-bold text-darkcyan">
                        {noOfQualifiedRoles}
                        {'/'}
                        {roles?.length}{' '}
                        <span className="lowercase">qualified role</span>
                    </span>
                </span>
            ) : (
                <span>
                    <span className="font-bold text-danger">None</span>
                </span>
            )
        },
    },
    {
        field: 'createdAt',
        header: 'Created At',
        initialShown: true,
        body: rowData => rowData.createdAt || 'N/A',
    },
    {
        field: 'gender',
        header: 'Gender',
        initialShown: false,
        body: rowData => rowData.genderValue || 'N/A',
    },
    {
        field: 'age',
        header: 'Age',
        initialShown: false,
        body: rowData => rowData.age || 'N/A',
    },
    {
        field: 'dob',
        header: 'Date Of Birth',
        initialShown: false,
        body: rowData => rowData.dob || 'N/A',
    },
    {
        header: 'Address Type',
        field: 'type',
        initialShown: false,
        body: rowData => rowData.type || 'N/A',
    },
    {
        header: 'Address',
        field: 'address',
        initialShown: false,
        body: rowData => rowData.address || 'N/A',
    },
    {
        header: 'Address Line 1',
        field: 'addressLine1',
        initialShown: false,
        body: rowData => rowData.addressLine1 || 'N/A',
    },
    {
        header: 'Address Line 2',
        field: 'addressLine2',
        initialShown: false,
        body: rowData => rowData.addressLine2 || 'N/A',
    },
    {
        header: 'Address Line 3',
        field: 'addressLine3',
        initialShown: false,
        body: rowData => rowData.addressLine3 || 'N/A',
    },
    {
        header: 'Address Line 4',
        field: 'addressLine4',
        initialShown: false,
        body: rowData => rowData.addressLine4 || 'N/A',
    },
    {
        header: 'City',
        field: 'city',
        initialShown: false,
        body: rowData => rowData.city || 'N/A',
    },
    {
        header: 'State',
        field: 'state',
        initialShown: false,
        body: rowData => rowData.state || 'N/A',
    },
    {
        header: 'Country',
        field: 'country',
        initialShown: false,
        body: rowData => rowData.country || 'N/A',
    },
    {
        header: 'Postal Code',
        field: 'postalCode',
        initialShown: false,
        body: rowData => rowData.postalCode || 'N/A',
    },
    {
        header: 'Phone',
        field: 'phone',
        initialShown: false,
        body: rowData => (rowData?.phone?.length > 9 ? rowData?.phone : 'N/A'),
    },
]

export const hcpStaticListColumnList = [
    {
        field: 'name',
        header: 'Name',
        initialShown: true,
        body: rowData => rowData.name || 'N/A',
    },
    {
        field: 'description',
        header: 'Description',
        initialShown: true,
        body: rowData => rowData.description || 'N/A',
    },
    {
        field: 'numOfPatients',
        header: 'Number of Patients',
        initialShown: true,
        body: rowData => rowData.numOfPatients || 0,
    },
    {
        field: 'createdAt',
        header: 'Created At',
        initialShown: true,
        body: rowData => rowData.createdAt || 'N/A',
    },
]

export const hcpSupportTeamColumnList = [
    {
        field: 'name',
        header: 'Name',
        initialShown: true,
        body: rowData => rowData.name || 'N/A',
    },
    {
        field: 'description',
        header: 'Description',
        initialShown: true,
        body: rowData => rowData.description || 'N/A',
    },
    {
        field: 'hospitalName',
        header: 'Hospital Name',
        initialShown: true,
        body: rowData => rowData.hospitalName || 'N/A',
    },
    {
        field: 'numberOfParticipants',
        header: 'Number of Participants',
        initialShown: true,
        body: rowData => rowData.numberOfParticipants || 0,
    },
    {
        field: 'createdAt',
        header: 'Created At',
        initialShown: true,
        body: rowData => rowData.createdAt || 'N/A',
    },
]

export const hcpPatientColumnList = [
    {
        field: 'subRefName',
        header: 'Patient Name',
        initialShown: true,
        body: rowData => rowData.subRefName || 'N/A',
    },
    {
        field: 'subRefEmail',
        header: 'Patient Email',
        initialShown: true,
        body: rowData => rowData.subRefEmail || 'N/A',
    },
    {
        field: 'hospitalName',
        header: 'Hospital Name',
        initialShown: true,
        body: rowData => rowData.hospitalName || 'N/A',
    },
    {
        field: 'createdAt',
        header: 'Created At',
        initialShown: true,
        body: rowData => rowData.createdAt || 'N/A',
    },
]

export const hcpRoleColumnList = [
    {
        field: 'hospitalName',
        header: 'Hospital Name',
        initialShown: true,
        body: rowData => rowData.hospitalName || 'N/A',
    },
    {
        field: 'hospitalNumber',
        header: 'Hospital Number',
        initialShown: true,
        body: rowData => rowData.hospitalNumber || 'N/A',
    },
    {
        field: 'roleName',
        header: 'Role Name',
        initialShown: true,
        body: rowData => rowData.roleName || 'N/A',
    },
    {
        field: 'roleDescription',
        header: 'Role Description',
        initialShown: true,
        body: rowData => rowData.roleDescription || 'N/A',
    },
    {
        field: 'qualified',
        header: 'Qualified',
        initialShown: true,
        body: rowData => {
            return (
                <Tag
                    className="px-3"
                    severity={rowData['qualified'] ? 'success' : 'danger'}
                    value={rowData['qualified'] ? 'Yes' : 'No'}
                />
            )
        },
    },
    {
        field: 'active',
        header: 'Active',
        initialShown: true,
        body: rowData => {
            return (
                <Tag
                    className="px-3"
                    severity={rowData['active'] ? 'success' : 'danger'}
                    value={rowData['active'] ? 'Yes' : 'No'}
                />
            )
        },
    },
    {
        field: 'createdAt',
        header: 'Created At',
        initialShown: true,
        body: rowData => rowData.createdAt || 'N/A',
    },
]
